import React from 'react';
import { Square, UtensilsCrossed, Bath, ArrowLeft, ArrowRight } from 'lucide-react';

interface KeyElementsStepProps {
  value: {
    keyElements: {
      windows: boolean;
      kitchen: boolean;
      bathroom: boolean;
    };
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const KeyElementsStep: React.FC<KeyElementsStepProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const handleElementToggle = (element: keyof typeof value.keyElements) => {
    onChange('keyElements', {
      ...value.keyElements,
      [element]: !value.keyElements[element]
    });
  };

  return (
    <div className="space-y-6">
      {/* Boutons de navigation compacts en haut */}
      <div className="flex justify-between items-center pb-4 border-b border-neutral-200">
        <h2 className="text-base font-semibold text-primary">Éléments à rénover</h2>
        <div className="flex items-center gap-2 ml-4">
          {onBack && (
            <button
              type="button"
              onClick={onBack}
              className="px-3 py-2 text-sm font-medium text-neutral-700 bg-white border border-neutral-300 rounded-lg hover:bg-neutral-50 transition-colors flex items-center gap-1"
            >
              <ArrowLeft className="h-4 w-4" />
              Précédent
            </button>
          )}
          <button
            type="button"
            onClick={onNext}
            className="px-3 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary-dark transition-colors flex items-center gap-1"
          >
            Suivant
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
      
      <div className="grid grid-cols-3 gap-4">
        <ElementCard
          icon={<Square className="h-8 w-8" />}
          label="Fenêtres"
          description="À remplacer"
          selected={value.keyElements.windows}
          onClick={() => handleElementToggle('windows')}
        />
        <ElementCard
          icon={<UtensilsCrossed className="h-8 w-8" />}
          label="Cuisine"
          description="À rénover"
          selected={value.keyElements.kitchen}
          onClick={() => handleElementToggle('kitchen')}
        />
        <ElementCard
          icon={<Bath className="h-8 w-8" />}
          label="Salle de bain"
          description="À refaire"
          selected={value.keyElements.bathroom}
          onClick={() => handleElementToggle('bathroom')}
        />
      </div>
    </div>
  );
};

interface ElementCardProps {
  icon: React.ReactNode;
  label: string;
  description: string;
  selected: boolean;
  onClick: () => void;
}

const ElementCard: React.FC<ElementCardProps> = ({
  icon,
  label,
  description,
  selected,
  onClick
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`
      card flex flex-col items-center p-6 transition-all
      ${selected ? 'ring-2 ring-primary bg-primary/5' : 'hover:bg-neutral-50'}
    `}
  >
    <div className={`mb-4 ${selected ? 'text-primary' : 'text-neutral-600'}`}>
      {icon}
    </div>
    <span className={`font-medium mb-2 ${selected ? 'text-primary' : 'text-neutral-700'}`}>
      {label}
    </span>
    <p className="text-sm text-neutral-500 text-center">
      {description}
    </p>
  </button>
);

export default KeyElementsStep;